import "./styles/style.less";
import { MainRouter } from "./Layout/MainRouter";
import { applyOrgTheme } from "./Layout/applyOrgTheme";

const savedTheme = localStorage.getItem("Theme");
if (savedTheme && savedTheme !== "default") {
  applyOrgTheme(parseInt(savedTheme));
}

function App() {
  return <MainRouter />;
}

export default App;
